import { t } from '../../components/one-translation-bundle/translation-bundles';
import type { Reference } from '../../models/Reference';
import { dialogOptions } from '../../components/shared/dialogs/one-dialog-options/dialog-options.controller';
import type { FetchResponse, RequestParams } from '@sydle/ui-api';

export type SelectUserArgs = {
  name: string;
  reference: Reference;
};

export async function selectUser(users: SelectUserArgs[]): Promise<any> {
  const options = users.map((user) => {
    return {
      label: user.name,
      value: user.reference._id,
    };
  });

  const userIdToTransfer = await dialogOptions({
    title: t('WORKSPACE_MESSAGES', 'BPM.EXECUTION.TOOL_BAR.PLAY'),
    props: {
      label: t('WORKSPACE_MESSAGES', 'DELEGATION.USER_RESPONSIBLE'),
      options,
    },
    elementToAppend: document.body,
    dialogPosition: 'fixed',
  });
  return users.find((user) => user.reference._id === userIdToTransfer);
}

export function hasPendingDelegation(response: FetchResponse): boolean {
  return response.error?.status === 300 && response.error?.data?._userDelegation?.length;
}

export function hasDefinedDelegation(params: Partial<RequestParams>): boolean {
  return params.body?._delegationUser;
}
